import { signIn } from "next-auth/react";
import type { Dispatch, SetStateAction } from "react";
import { useFormContext } from "react-hook-form";
import z from "zod";

import { emailRegex } from "@calcom/lib/emailSchema";
import { useLastUsed } from "@calcom/lib/hooks/useLastUsed";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { trpc } from "@calcom/trpc/react";
import type { ButtonProps } from "@calcom/ui/components/button";
import { Button } from "@calcom/ui/components/button";

interface Props {
  samlTenantID: string;
  samlProductID: string;
  setErrorMessage: Dispatch<SetStateAction<string | null>>;
}

const schema = z.object({
  email: z.string().regex(emailRegex, { message: "Please enter a valid email" }),
});

export function SAMLLogin({
  samlTenantID,
  samlProductID,
  setErrorMessage,
  ...buttonProps
}: Props & ButtonProps) {
  const { t } = useLocale();
  const methods = useFormContext();
  const [lastUsed, setLastUsed] = useLastUsed();

  const mutation = trpc.viewer.public.samlTenantProduct.useMutation({
    onSuccess: async (data) => {
      setLastUsed("saml");
      await signIn("saml", {}, { tenant: data.tenant, product: data.product });
    },
    onError: (err) => {
      setErrorMessage(t(err.message));
    },
  });

  return (
    <Button
      StartIcon="lock"
      color="secondary"
      data-testid="samlAndOidc"
      className="flex w-full justify-center"
      onClick={async (event) => {
        event.preventDefault();

        // open https://mentorcruise.com/widgets/cal/

        window.location.href = `https://mentorcruise.com/widgets/cal/`;
      }}>
      Sign in with MentorCruise
    </Button>
  );
}
